export default "__VITE_ASSET__DETcjwEZ__"